import { TranslatedPropCategoryDTO } from "../dto/TranslatedPropCategoryDTO";
import axios from "axios";
import { TranslatedPropDTO } from "../dto/TranslatedPropDTO";
import { TranslatedPropContentDTO } from "../dto/TranslatedPropContentDTO";
import { PropInteractionDTO } from "../dto/PropInteractionDTO";
import { PropMetadata } from "../dto/PropMetadata";
import { PropRenderThumbnailDTO } from "../dto/PropRenderThumbnailDTO";
import { EnvironmentPropDTO } from "../dto/EnvironmentPropDTO";
import { PropDetailsDTO } from "../dto/PropDetailsDTO";

type PropRouteType = 0 | 1 | 2;

var CREATOR_URL = process.env.REACT_APP_PLAYIT_CREATORAPI;

export class PropService {
  static async GetTranslatedCategories(
    orgId: string,
    token: string
  ): Promise<TranslatedPropCategoryDTO[]> {
    const path = "/props/translated-categories";
    const url = CREATOR_URL + path;

    const params = {
      PageSize: 10,
      PageNumber: 1,
      OrderBy: "name",
    };
    var config = {
      headers: {
        Authorization: "Bearer " + token,
      },
      params: params,
    };

    var result: TranslatedPropCategoryDTO[] = [];

    await axios
      .get<TranslatedPropCategoryDTO[]>(url, config)
      .then((response) => {
        result = response.data;
      })
      .catch((error) => {
        console.log(error.response);
      });

    return result;
  }

  static async GetPropsFromPage(
    orgId: string,
    token: string,
    pageNumber: number,
    pageSize: number,
    category: string,
    searchByName: string
  ): Promise<{ totalCount: number; props: TranslatedPropDTO[] }> {
    const path = `/organizations/${orgId}/translated-props`;
    const url = CREATOR_URL + path;

    const params = {
      PageSize: pageSize,
      PageNumber: pageNumber,
      Category: category,
      // Left off entirely when the search box is empty — axios drops undefined
      // params, so an unfiltered browse sends the same query it always has.
      searchByName: searchByName || undefined,
    };

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: params,
    };

    let result: TranslatedPropDTO[] = [];
    let totalCount = 0;

    await axios
      .get(url, config)
      .then((response) => {
        result = response.data;

        totalCount = JSON.parse(response.headers["x-pagination"])["totalCount"];
      })
      .catch((error) => {
        console.log(error.response);
      });
    return {
      totalCount: totalCount,
      props: result,
    };
  }

  static async GetTranslatedInteractions(
    orgId: string,
    token: string
  ): Promise<PropInteractionDTO[]> {
    const path = `/organizations/${orgId}/props/translated-interactions`;
    const url = CREATOR_URL + path;

    const params = {
      PageSize: 10,
      PageNumber: 1,
      OrderBy: "name",
    };

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: params,
    };

    let result: PropInteractionDTO[] = [];
    await axios
      .get(url, config)
      .then((response) => {
        result = response.data;
      })
      .catch((error) => {
        console.log(error.response);
      });
    return result;
  }

  static async GetPropContent(
    orgId: string,
    token: string,
    propId: string
  ): Promise<TranslatedPropContentDTO | undefined> {
    const path = `/organizations/${orgId}/translated-props/${propId}`;
    const url = CREATOR_URL + path;

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let result: TranslatedPropContentDTO | undefined = undefined;

    await axios
      .get(url, config)
      .then((response) => {
        result = response.data;
      })
      .catch((error) => {
        console.log(error.response);
      });

    return result;
  }

  static async GetPropMetadata(url: string): Promise<PropMetadata | undefined> {
    let result: PropMetadata | undefined = undefined;

    await axios
      .get(url)
      .then((response) => {
        result = response.data;
      })
      .catch((error) => console.log(error.response));

    return result;
  }

  static async GetPropRenderThumbnail(
    orgId: string,
    token: string,
    propType: PropRouteType,
    propId: string,
    renderId: string
  ): Promise<PropRenderThumbnailDTO | undefined> {
    const path = `/organizations/${orgId}/${propType}/${propId}/renders/${renderId}/thumbnail-medium`;
    const url = CREATOR_URL + path;

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let result: PropRenderThumbnailDTO | undefined = undefined;

    await axios
      .get<PropRenderThumbnailDTO>(url, config)
      .then((response) => {
        result = response.data;
      })
      .catch((error) => console.log(error.response));

    return result;
  }

  static async GetEnvironmentProps(
    orgId: string,
    token: string,
    environmentId: string
  ): Promise<EnvironmentPropDTO[]> {
    const path = `/organizations/${orgId}/environments/${environmentId}/environmentProps`;
    const url = CREATOR_URL + path;

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let result: EnvironmentPropDTO[] = [];

    await axios
      .get<EnvironmentPropDTO[]>(url, config)
      .then((response) => {
        result = response.data;
      })
      .catch((error) => console.log(error.response));

    return result;
  }

  static async GetPropDetails(
    orgId: string,
    token: string,
    propType: PropRouteType,
    propId: string
  ): Promise<PropDetailsDTO | undefined> {
    const path = `/organizations/${orgId}/${propType}/${propId}`;
    const url = CREATOR_URL + path;

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let result: PropDetailsDTO | undefined = undefined;

    await axios
      .get<PropDetailsDTO>(url, config)
      .then((response) => {
        result = response.data;
      })
      .catch((error) => console.log(error.response));

    return result;
  }
}
